export const POPUP_SET_INITIAL_VALUES = "contractDetails: POPUP_SET_INITIAL_VALUES";
export const POPUP_UPDATE_QTY = "contractDetails: POPUP_UPDATE_QTY";
export const POPUP_UPDATE_DATE = "contractDetails: POPUP_UPDATE_DATE";

export function atcPopupupdateQty(newQty: number) {
  return {
    type: POPUP_UPDATE_QTY,
    payload: newQty,
  };
}

export function atcPopupupdateDate(newDate: Date) {
  return {
    type: POPUP_UPDATE_DATE,
    payload: newDate,
  };
}
